import { i18n } from 'invision-core';
import LocaleKeys from '../../../../locales/keys';
function ExternalAuthorizationsController($scope) {
  var _this = this;
  var removeAuthConfPopupApi = null;
  var DELETE_ROW_OPTION_ID = 'DELETE_ROW_OPTION_ID';
  this.$onInit = function () {
    _this.LocaleKeys = LocaleKeys;
    $scope.identifierAbbreviationLabel = i18n.translate(LocaleKeys.IDENTIFIER_ABBREVIATION);
    _this.tableData = {
      data: _this.externalAuthorizations,
      columnDefs: [{
        field: 'name',
        displayName: i18n.translate(LocaleKeys.NAME),
        width: '*'
      }, {
        field: 'externalSubscriberId',
        displayName: i18n.translate(LocaleKeys.PROFILE_PAGE.EXTERNAL_SUBSCRIBER_ID),
        cellTemplate: require('./subscriberIdTemplate.html'),
        width: '*'
      }, {
        field: 'expirationDate',
        displayName: i18n.translate(LocaleKeys.PROFILE_PAGE.EXPIRATION_DATE),
        cellTemplate: require('./expirationDateTemplate.html'),
        width: '*'
      }, {
        field: 'tokenActive',
        displayName: i18n.translate(LocaleKeys.PROFILE_PAGE.TOKEN_ACTIVE),
        width: '*'
      }, {
        field: 'menu',
        displayName: '',
        cellTemplate: require('./menuCellTemplate.html'),
        width: '50'
      }]
    };
    $scope.datatable = {
      handleListSelected: function handleListSelected(entityId) {
        return _this.handleRowMoreCellListSelected.bind(_this, entityId);
      },
      moreCellOptions: [{
        id: DELETE_ROW_OPTION_ID,
        title: i18n.translate(LocaleKeys.REMOVE)
      }]
    };
    _this.removeAuthConfPopupConfig = {
      onRegisterApi: function onRegisterApi(event) {
        removeAuthConfPopupApi = event.api;
      }
    };
  };
  this.$onChanges = function (changesObj) {
    if (changesObj.externalAuthorizations && _this.externalAuthorizations && _this.tableData) {
      _this.tableData.data = changesObj.externalAuthorizations.currentValue;
    }
  };
  this.handleResultRemoveAuthConfirmationPopup = function (isConfirmed) {
    if (isConfirmed) {
      _this.onDeleteRow()(_this.deletingRowId);
      removeAuthConfPopupApi.close();
    } else {
      removeAuthConfPopupApi.close();
    }
    _this.deletingRowId = null;
  };
  this.handleCloseRemoveAuthConfirmationPopup = function () {
    removeAuthConfPopupApi.close();
  };
  this.deleteRow = function (rowId) {
    _this.deletingRowId = rowId;
    removeAuthConfPopupApi.open();
  };
  this.handleRowMoreCellListSelected = function (entityId, _ref) {
    var selectedListItem = _ref.item;
    if (selectedListItem.id === DELETE_ROW_OPTION_ID) {
      _this.deleteRow(entityId);
    }
  };
}
export default {
  bindings: {
    externalAuthorizations: '<',
    onDeleteRow: '&'
  },
  template: require('./externalAuthorizations.html'),
  controller: ExternalAuthorizationsController,
  controllerAs: 'externalAuthorizationsController'
};